var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6C2 4.495 2.78 2.92 4 2C4 2.845 4.69 4 6 4C6.79565 4 7.55871 4.31607 8.12132 4.87868C8.68393 5.44129 9 6.20435 9 7C9 7.386 8.921 7.752 8.788 8.091C9.52976 8.67969 10.2602 9.28246 10.979 9.899L8.899 11.979C8.28271 11.26 7.67994 10.5296 7.091 9.788C6.74387 9.92652 6.37375 9.99844 6 10C3.79 10 2 8.21 2 6ZM14.152 12.848L15.493 11.507C16.114 11.8267 16.8016 11.9956 17.5 12C18.6935 12 19.8381 11.5259 20.682 10.682C21.5259 9.83806 22 8.69347 22 7.5C22 6.775 21.812 6.099 21.507 5.493L18 9L16 7L19.507 3.493C18.886 3.1733 18.1984 3.00441 17.5 3C16.3065 3 15.1619 3.47411 14.318 4.31802C13.4741 5.16193 13 6.30652 13 7.5C13 8.225 13.188 8.901 13.493 9.507L3 20L5 22L11.848 15.152C13.7314 17.0844 15.7272 18.9039 17.825 20.601L19.25 21.75L20.75 20.25L19.601 18.825C17.9039 16.7272 16.0844 14.7314 14.152 12.848Z",
    fill: "#674366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceTwo);
export default __webpack_public_path__ + "static/media/serviceTwo.eccb01e8f54984f63483230d12b53fb4.svg";
export { ForwardRef as ReactComponent };